import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateImportJobMutationVariables = Types.Exact<{
  input: Types.CreateImportJobInput;
}>;


export type CreateImportJobMutation = { createImportJob?: { id: string, jobScheduleId: string, status: Types.JobEntityStatusEnum } | null };


export const CreateImportJobDocument = /*#__PURE__*/ gql`
    mutation createImportJob($input: CreateImportJobInput!) {
  createImportJob(data: $input) {
    id
    jobScheduleId
    status
  }
}
    `;

export function useCreateImportJobMutation() {
  return Urql.useMutation<CreateImportJobMutation, CreateImportJobMutationVariables>(CreateImportJobDocument);
};